

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.MappingScreen = (function () {

    function MappingScreen(preview) {

        this.advancedConfigs = new Greenmile.DataImport.AdvancedConfigurations();
        this.value = null;

        App.Forms.DataImport = App.Forms.DataImport || {};
        App.Forms.DataImport.MappingScreen = this;

        this.getPreviewData = function() {
            return preview;
        };

        this.createBaseStructure = function() {

            this.table = new Greenmile.DataImport.FieldsMappingTable( this.getPreviewData(), this.type );

            this.table.fillLineFunction = this.setLinesValue;
            this.table.fillLineFunction.bind(this.table);

            var titleContainer = Greenmile.DataImport.Utils.getTitle(this.title);

            this.rootEl = document.createElement('div');
            this.rootEl.className = this.className;

            var searchContainer = document.createElement('div');
            searchContainer.className = 'searchContainer';

            this.layoutName = new Monet.UI.Fields.Render({
                label: 'Greenmile.DataImport.layoutName',
                type: 'TEXT'
            }).render();
            this.layoutName.setId('layoutName');

            searchContainer.appendChild(this.layoutName.rootEl);
            searchContainer.appendChild(this.advancedConfigs.render());

            this.tableContainer = document.createElement('div');
            this.tableContainer.className = 'tableContainer';

            this.rootEl.appendChild(titleContainer);
            this.rootEl.appendChild(searchContainer);

            if ( this.renderPreview ) {
                this.rootEl.appendChild(this.renderPreview());
            }
            this.rootEl.appendChild(this.tableContainer);

        };

        this.setValue = function(value) {
            this.value = value;
        };

        this.show = function(value) {

            if(value) {
                this.value = value;
            }
            this.render();

            var container = document.querySelector('.form_DataImport');
            container.innerHTML = '';
            container.parentNode.setAttribute('screen', this.className);

            this.tableContainer.appendChild(this.table.render(this.value));
            this.setValue(this.value);

            container.appendChild(this.rootEl );

            return this;
        };

        this.showUploadScreen = function() {
            var uploadButton = document.querySelector('#DataImport .lateralMenu .iconsContainer .upload').parentNode;
            App.Forms.DataImport.LateralMenu.showUploadScreen({target: uploadButton});
        };

        this.handlerToogleLoadingInBtn = () => {
            const buttons = [this.btnSave, this.btnProcess, this.btnBack];
            for(let i = 0; i < buttons.length; i++) {
                if(i < 2) {
                    buttons[i].toggleLoadingInBtn();
                } else {
                    buttons[i].rootEl.disabled = !buttons[i].rootEl.disabled;
                }
            }
        };

        this.saveLayout = function(callback) {
            Greenmile.DataImport.Utils.clearErrorMessage();

            var result = this.validate();

            if(result.status) {
                this.handlerToogleLoadingInBtn();
                var request = new Monet.Ajax();
                var importType = App.Forms.DataImport.MappingTemplate.getTypeImportSelected();
                request.url = '/TextFileLayout/?importType=' + importType;
                request.method = ((this.value && this.value.id) ? 'PUT' : 'POST');
                request.data = result.value;

                request.error = function(data) {
                    this.handlerToogleLoadingInBtn();
                    Greenmile.DataImport.Utils.showErrorMessage(data.response);
                }.bind(this);

                request.success = function(data) {

                    if(callback) {
                        callback(data);
                    }
                    this.handlerToogleLoadingInBtn();
                    this.showUploadScreen();

                }.bind(this);

                request.send();

            } else {
                Greenmile.DataImport.Utils.showErrorMessage(result);
            }
            
        }.bind(this);

        this.saveAndProcess = function() {
            return function(data) {
                App.Objects.DataImport.processUploadedFile(App.Forms.DataImport.uploadFile, data.id, App.Forms.DataImport.MappingTemplate.getTypeImportSelected());
            };

        }();

        this.createButtons = function() {

            var scope = this;
            var container = document.createElement('div');
            container.className = 'MonetUIFormSectionButton';

            this.btnBack = new Monet.UI.Fields.Render({
                customJavaScript: this.back,
                label: 'DataImport.back',
                type: 'BUTTON'
            }).render();

            this.btnProcess = new Monet.UI.Fields.Render({
                customJavaScript: function() {
                    scope.saveLayout(scope.saveAndProcess);
                },
                label: 'DataImport.saveAndProcess',
                type: 'BUTTON'
            }).render();

            this.btnProcess.setId('goToStatusScreen');

            this.btnSave = new Monet.UI.Fields.Render({
                customJavaScript: function() { scope.saveLayout(); },
                label: 'default.button.save',
                type: 'BUTTON'
            }).render();

            this.btnSave.setId('saveLayout');

            container.appendChild(this.btnSave.rootEl);
            container.appendChild(this.btnProcess.rootEl);
            container.appendChild(this.btnBack.rootEl);

            return container;
        };

        this.setViewValue = function() {
            if (this.value) {
                this.layoutName.setValue(this.value.name);
            }
            this.table.setColumnsValue(this.value);
        }.bind(this);

        this.render = function() {

            this.createBaseStructure();

            this.rootEl.appendChild(  this.createButtons() );

            return this.rootEl;
        };

        this.back = function() {
            Greenmile.DataImport.Utils.clearErrorMessage();
            App.Forms.DataImport.CSVConfigurations.show(this.value, true);
        }.bind(this);

    }

    return MappingScreen;
}());
